import { OnboardingStep } from 'types/onboardingTypes'

export function getOutOfBreathInfo(): OnboardingStep {
  return {
    id: 'out_of_breath_info',
    type: 'custom',
  }
}
